import { Truck } from "lucide-react";

export default function DeliveryPage() {
  return (
    <div className="pt-28 lg:pt-44 pb-16" data-testid="delivery-page">
      <section className="max-w-3xl mx-auto px-6">
        <p className="font-accent text-xl text-sunset mb-1">good to know</p>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-8">Delivery</h1>

        <div className="bg-white/70 rounded-2xl border border-black/5 p-7 space-y-5 text-charcoal/75 leading-relaxed">
          <p>Orders are usually dispatched within 1–2 working days.</p>
          <ul className="space-y-3">
            <li className="flex items-start gap-3"><Truck size={18} className="text-olive mt-0.5" /> UK Tracked Delivery — £3.95</li>
            <li className="flex items-start gap-3"><Truck size={18} className="text-olive mt-0.5" /> Express Tracked Delivery — £5.95</li>
            <li className="flex items-start gap-3"><Truck size={18} className="text-olive mt-0.5" /> Complimentary UK Tracked Delivery on orders over £60</li>
            <li className="flex items-start gap-3"><Truck size={18} className="text-olive mt-0.5" /> Complimentary Click &amp; Collect from the Bude salon</li>
          </ul>
          <p>You'll receive tracking details once your order has been dispatched.</p>
        </div>
      </section>
    </div>
  );
}
